module.exports = __webpack_public_path__ + "static/media/tec1.25e825bf.jpg";